/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CompanyChangeEmail,
    CompanyChangeEmailFromJSON,
    CompanyChangeEmailToJSON,
    CompanyChangePassword,
    CompanyChangePasswordFromJSON,
    CompanyChangePasswordToJSON,
    CompanyLogin,
    CompanyLoginFromJSON,
    CompanyLoginToJSON,
    DefaultResponse,
    DefaultResponseFromJSON,
    DefaultResponseToJSON,
    LoginResponse,
    LoginResponseFromJSON,
    LoginResponseToJSON,
} from '../models';

export interface CompanyChangeEmailPostRequest {
    companyChangeEmail?: CompanyChangeEmail;
}

export interface CompanyLoginPostRequest {
    companyLogin?: CompanyLogin;
}

export interface CompanyLostPasswordPostRequest {
    email: string;
}

export interface CompanyPasswordPostRequest {
    companyChangePassword?: CompanyChangePassword;
}

export interface CompanyResetPasswordTokenPostRequest {
    token: string;
    newPassword: string;
}

/**
 * 
 */
export class CompanyAuthApi extends runtime.BaseAPI {

    /**
     * Cambiar email de un compañia ya logada
     */
    async companyChangeEmailPostRaw(requestParameters: CompanyChangeEmailPostRequest): Promise<runtime.ApiResponse<DefaultResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company/change_email`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompanyChangeEmailToJSON(requestParameters.companyChangeEmail),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DefaultResponseFromJSON(jsonValue));
    }

    /**
     * Cambiar email de un compañia ya logada
     */
    async companyChangeEmailPost(requestParameters: CompanyChangeEmailPostRequest): Promise<DefaultResponse> {
        const response = await this.companyChangeEmailPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Metodo para que la empresa pueda logar
     */
    async companyLoginPostRaw(requestParameters: CompanyLoginPostRequest): Promise<runtime.ApiResponse<LoginResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompanyLoginToJSON(requestParameters.companyLogin),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseFromJSON(jsonValue));
    }

    /**
     * Metodo para que la empresa pueda logar
     */
    async companyLoginPost(requestParameters: CompanyLoginPostRequest): Promise<LoginResponse> {
        const response = await this.companyLoginPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Metodo para que la empresa pueda deslogar
     */
    async companyLogoutPostRaw(): Promise<runtime.ApiResponse<LoginResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company/logout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseFromJSON(jsonValue));
    }

    /**
     * Metodo para que la empresa pueda deslogar
     */
    async companyLogoutPost(): Promise<LoginResponse> {
        const response = await this.companyLogoutPostRaw();
        return await response.value();
    }

    /**
     * Password olvidado
     */
    async companyLostPasswordPostRaw(requestParameters: CompanyLostPasswordPostRequest): Promise<runtime.ApiResponse<DefaultResponse>> {
        if (requestParameters.email === null || requestParameters.email === undefined) {
            throw new runtime.RequiredError('email','Required parameter requestParameters.email was null or undefined when calling companyLostPasswordPost.');
        }

        const queryParameters: any = {};

        if (requestParameters.email !== undefined) {
            queryParameters['email'] = requestParameters.email;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company/lost_password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DefaultResponseFromJSON(jsonValue));
    }

    /**
     * Password olvidado
     */
    async companyLostPasswordPost(requestParameters: CompanyLostPasswordPostRequest): Promise<DefaultResponse> {
        const response = await this.companyLostPasswordPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Cambiar contraseña de un compañia ya logada
     */
    async companyPasswordPostRaw(requestParameters: CompanyPasswordPostRequest): Promise<runtime.ApiResponse<DefaultResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company/password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompanyChangePasswordToJSON(requestParameters.companyChangePassword),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DefaultResponseFromJSON(jsonValue));
    }

    /**
     * Cambiar contraseña de un compañia ya logada
     */
    async companyPasswordPost(requestParameters: CompanyPasswordPostRequest): Promise<DefaultResponse> {
        const response = await this.companyPasswordPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Password olvidado
     */
    async companyResetPasswordTokenPostRaw(requestParameters: CompanyResetPasswordTokenPostRequest): Promise<runtime.ApiResponse<DefaultResponse>> {
        if (requestParameters.token === null || requestParameters.token === undefined) {
            throw new runtime.RequiredError('token','Required parameter requestParameters.token was null or undefined when calling companyResetPasswordTokenPost.');
        }

        if (requestParameters.newPassword === null || requestParameters.newPassword === undefined) {
            throw new runtime.RequiredError('newPassword','Required parameter requestParameters.newPassword was null or undefined when calling companyResetPasswordTokenPost.');
        }

        const queryParameters: any = {};

        if (requestParameters.newPassword !== undefined) {
            queryParameters['new_password'] = requestParameters.newPassword;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company/reset_password/{token}`.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters.token))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DefaultResponseFromJSON(jsonValue));
    }

    /**
     * Password olvidado
     */
    async companyResetPasswordTokenPost(requestParameters: CompanyResetPasswordTokenPostRequest): Promise<DefaultResponse> {
        const response = await this.companyResetPasswordTokenPostRaw(requestParameters);
        return await response.value();
    }

}
